import { render, staticRenderFns } from "./reviewListContainer.vue?vue&type=template&id=4d30226a&"
import script from "./reviewListContainer.vue?vue&type=script&lang=js&"
export * from "./reviewListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports